// assets/wishlist-notifier.js
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    const productTitle  = btn.getAttribute("data-product-title")  || "Titolo sconosciuto";
    const productHandle = btn.getAttribute("data-product-handle") || "handle-sconosciuto";

    // URL assoluto con il tuo dominio
    const productUrl    = `https://dreambrothers.it/products/${productHandle}`;

    // Testo del messaggio: l'URL completo viene riconosciuto e cliccabile
    const message = 
      `⭐️ Wishlist click!\n\n` +
      `🛍️ *${productTitle}*\n` +
      `🔗 ${productUrl}`;

    const chatId   = "440669255";
    const botToken = "8127268024:AAHGoLKLijS4wtlA5Ear0FvEm0ZHTCgpcoA";

    fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
        parse_mode: "Markdown",         // mantiene il grassetto sul titolo
        disable_web_page_preview: false // mostra l'anteprima link con immagine
      })
    });
  });
});
